module.exports = __webpack_public_path__ + "src/assets/img/kuzov4.f3516d4d.svg";